export const actionTypes = {
  updateProducts: 'updateProducts',
  updateLocations: 'updateLocations',
  updateLanguages: 'updateLanguages',
  updateIndustries: 'updateIndustries',
  updateSearch: 'updateSearch',
};

export const initial = {
  products: [],
  locations: [],
  languages: [],
  industries: [],
  search: [{value: 'search--filter', label: ''}],
};

/**
 * Defines a reducer for the filters' state.
 *
 * @param {object} state - The current state.
 * @param {string} type - The action type.
 * @param {object} payload - The action's data.
 *
 * @returns {object} - The new state.
 */
export function reducer(state, {type, payload}) {
  switch (type) {
    case actionTypes.updateProducts:
      return {...state, products: payload};
    case actionTypes.updateLocations:
      return {...state, locations: payload};
    case actionTypes.updateLanguages:
      return {...state, languages: payload};
    case actionTypes.updateIndustries:
      return {...state, industries: payload};
    case actionTypes.updateSearch:
      return {...state, search: payload};
    case actionTypes.remove:
      // eslint-disable-next-line no-case-declarations
      const {filter, value} = payload;

      if (filter === 'search') return {...state, search: initial.search};

      return {
        ...state,
        [filter]: [...state[filter].filter(item => item.value !== value)],
      };
    default:
      throw new Error();
  }
}
